import React, { useEffect } from "react";
import { navigate, useStaticQuery } from "gatsby";
import { FormattedDate } from "react-intl";
import Wrapper from "../components/structure/Wrapper/Wrapper";
import Heading from "../components/text/Heading/Heading";
import Spacer from "../components/structure/Spacer/Spacer";
import SEO from "../components/modules/SEO/SEO";
import { jsx as ___EmotionJSX } from "@emotion/react";
const BarrierefreiheitPage = () => {
  const metaData = useStaticQuery(query);
  const addresses = metaData.directusCompany.addresses;
  const accessibility = metaData.directusProject;
  const executives = metaData.directusCompany.executives.map(e => e.name).join(', ');
  useEffect(() => {
    if (!accessibility.show_accessibility) {
      navigate("/");
    }
  }, [accessibility.show_accessibility]);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SEO, {
    title: "Erkl\xE4rung zur Barrierefreiheit f\xFCr Dienstleistungen"
  }), ___EmotionJSX(Spacer, null), ___EmotionJSX(Wrapper, null, ___EmotionJSX(Heading, null, "Erkl\xE4rung zur Barrierefreiheit f\xFCr Dienstleistungen"), ___EmotionJSX("p", null, "Im Rahmen unserer Barrierefreiheitserkl\xE4rung m\xF6chten wir Ihnen einen \xDCberblick \xFCber den Stand der Vereinbarkeit der unten beschriebenen Dienstleistung(en) mit den Anforderungen der Barrierefreiheit nach gesetzlichen Vorschriften (insbesondere mit dem Barrierefreiheitsst\xE4rkungsgesetz \u2013 BFSG) geben."), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX("div", null, ___EmotionJSX("h2", null, "Angaben zum Dienstleistungserbringer"), ___EmotionJSX("address", null, ___EmotionJSX("p", null, " ", metaData.directusCompany.company_name, " ", ___EmotionJSX("br", null), addresses[0].street, " ", addresses[0].number, " ", ___EmotionJSX("br", null), addresses[0].zip_code, " ", addresses[0].city)), ___EmotionJSX("p", null, ___EmotionJSX("b", null, "Vertreten durch"), ___EmotionJSX("br", null), executives)), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX("div", null, ___EmotionJSX("h2", null, "Allgemeine Beschreibung der Dienstleistung"), ___EmotionJSX("p", {
    dangerouslySetInnerHTML: {
      __html: accessibility.accessibility_description
    }
  })), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX("div", null, ___EmotionJSX("h2", null, "Erl\xE4uterungen zur Durchf\xFChrung der Dienstleistung"), ___EmotionJSX("p", {
    dangerouslySetInnerHTML: {
      __html: accessibility.accessibility_implementation
    }
  })), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX("div", null, ___EmotionJSX("h2", null, "Stand der Vereinbarkeit mit den Anforderungen"), ___EmotionJSX("p", null, "Die oben genannte Dienstleistung ist vollst\xE4ndig mit dem Barrierefreiheitsst\xE4rkungsgesetz (BFSG) vereinbar.")), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX("div", null, ___EmotionJSX("h2", null, "Erstellung der Barrierefreiheitserkl\xE4rung"), ___EmotionJSX("p", null, "Datum der Erstellung der Barrierefreiheitserkl\xE4rung: ", ___EmotionJSX(FormattedDate, {
    value: accessibility.accessibility_date_creation,
    timeZone: "UTC",
    year: "numeric",
    month: "numeric",
    day: "2-digit"
  })), ___EmotionJSX("p", null, "Datum der letzten \xDCberpr\xFCfung der o. g. Leistungen hinsichtlich der Anforderungen zur Barrierefreiheit: ", ___EmotionJSX(FormattedDate, {
    value: accessibility.accessibility_date_check,
    timeZone: "UTC",
    year: "numeric",
    month: "numeric",
    day: "2-digit"
  }))), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX("div", null, ___EmotionJSX("h2", null, "Einsch\xE4tzung zum Stand der Barrierefreiheit"), ___EmotionJSX("p", null, "Die Einsch\xE4tzung zum Stand der Barrierefreiheit beruht auf unserer Selbsteinsch\xE4tzung.")), ___EmotionJSX(Spacer, {
    height: 20
  })));
};
export default BarrierefreiheitPage;
const query = "2497884466";